import classNames from 'classnames';
import type { InputHTMLAttributes, ReactNode } from 'react';

import styles from './index.module.scss';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> & {
  readonly prefix?: ReactNode;
  readonly suffix?: ReactNode;
  readonly isDanger?: boolean;
};

const EvaInput = ({ prefix, suffix, className, isDanger, ...props }: Props) => {
  return (
    <label className={classNames(styles.input, isDanger && styles.danger, className)}>
      {prefix && <span className={styles.prefix}>{prefix}</span>}
      <input className={styles.control} {...props} />
      {suffix && <span className={styles.suffix}>{suffix}</span>}
    </label>
  );
};

export default EvaInput;
